// extracted by mini-css-extract-plugin
export default {"description":"lNmVXj64GjUjm7ztyRdphw=="};